module.exports = __webpack_public_path__ + "video-274b4a06056b.mp4";